/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.identity.defs'

type $nsid = typeof $nsid

export { $nsid }

type IdentityInfo = {
  $type?: 'com.atproto.identity.defs#identityInfo'
  did: l.DidString

  /**
   * The complete DID document for the identity.
   */
  didDoc: l.LexMap

  /**
   * The validated handle of the account; or 'handle.invalid' if the handle did not bi-directionally match the DID document.
   */
  handle: l.HandleString
}

export type { IdentityInfo }

const identityInfo = /*#__PURE__*/ l.typedObject<IdentityInfo>(
  $nsid,
  'identityInfo',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    didDoc: /*#__PURE__*/ l.lexMap(),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
  }),
)

export { identityInfo }
